var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useState } from 'react';
import { formatNumber } from '../../../utils/number';
var CartContext = createContext(null);
export var CartProvider = function (props) {
    var currencySymbol = '$';
    var _a = useState(props.items), items = _a[0], setItems = _a[1];
    var shipping = props.shipping;
    useEffect(function () {
        setItems(props.items);
    }, [props.items]);
    var updateItemQuantity = function (updateItem, quantity) {
        setItems(function (items) {
            return items.map(function (item) { return (item === updateItem ? __assign(__assign({}, updateItem), { quantity: quantity }) : item); });
        });
    };
    var removeItem = function (itemToRemove) {
        setItems(function (items) {
            return items.filter(function (item) { return item !== itemToRemove; });
        });
    };
    return (_jsx(CartContext.Provider, __assign({ value: { items: items, shipping: shipping, updateItemQuantity: updateItemQuantity, removeItem: removeItem, currencySymbol: currencySymbol } }, { children: props.children })));
};
export var useCart = function () {
    var context = useContext(CartContext);
    if (!context)
        throw new Error('CartProvider not found in root');
    return context;
};
export var useCartMainItem = function () {
    var items = useCart().items;
    var mainItem = items.find(function (item) { return item.image; });
    return mainItem;
};
export var useCartShipping = function () {
    var shipping = useCart().shipping;
    if (!shipping)
        return null;
    return shipping;
};
export var useCartShippingAmount = function () {
    var _a;
    var shipping = useCartShipping();
    return (_a = shipping === null || shipping === void 0 ? void 0 : shipping.amount) !== null && _a !== void 0 ? _a : 0;
};
export var useCartRequiresShipping = function () {
    var shipping = useCartShipping();
    return !!shipping;
};
export var useCartCheckoutItems = function () {
    var items = useCart().items;
    return items.reduce(function (acc, item) {
        if (item.quantity) {
            var input = { planId: item.planId, quantity: item.quantity };
            if (item.plan)
                input.plan = item.plan;
            acc.push(input);
        }
        return acc;
    }, []);
};
export var useCartTotal = function () {
    var _a;
    var _b = useCart(), items = _b.items, shipping = _b.shipping, currencySymbol = _b.currencySymbol;
    var subtotalCost = items.reduce(function (total, item) {
        return total + getCartItemAmount(item) * item.quantity;
    }, 0);
    var shippingCost = (_a = shipping === null || shipping === void 0 ? void 0 : shipping.amount) !== null && _a !== void 0 ? _a : 0;
    var totalCost = subtotalCost + shippingCost;
    return {
        totalCost: totalCost,
        shippingCost: shippingCost,
        subtotalCost: subtotalCost,
        formattedSubtotal: "".concat(currencySymbol).concat(formatNumber(subtotalCost)),
        formattedShipping: "".concat(currencySymbol).concat(formatNumber(shippingCost)),
        formattedTotal: "".concat(currencySymbol).concat(formatNumber(totalCost)),
    };
};
export var getCartItemAmount = function (item) {
    if (typeof item.amountKey === 'string')
        return item[item.amountKey] || 0;
    return item.amount || 0;
};
//# sourceMappingURL=Cart.js.map